import * as React from 'react';
import { Input, MaskedInput } from '@cian/ui-kit';
import { ClientComponent } from '../ClientComponent';

interface IPhoneInputProps {
  disabled?: boolean;
  onChange?(value: string): void;
  name?: string;
  size?: 'M' | 'XS';
  value?: string;
  invalid?: boolean;
}

export const PhoneInput: React.FC<IPhoneInputProps> = ({ ...props }) => {
  const inputProps = {
    type: 'text' as const,
    ...props,
  };

  const handleInputChange = React.useCallback(
    (_event: React.ChangeEvent<HTMLInputElement>, value: string) => {
      const { onChange } = props;

      if (onChange) {
        onChange(value);
      }
    },
    [props],
  );

  const preprocessInputChars = React.useCallback((inputChar: string, maskedValue: string) => {
    if (inputChar === '8' && maskedValue === '') {
      return '';
    }

    return inputChar;
  }, []);

  return (
    <ClientComponent fallback={<Input {...inputProps} onChange={handleInputChange} />}>
      <MaskedInput
        lazy
        mask="+{7} 000 000-00-00"
        placeholderChar=" "
        placeholder=""
        preprocessInputChars={preprocessInputChars}
        {...inputProps}
      />
    </ClientComponent>
  );
};
